<div class="schedule-calendar card">
  <div class="card-header schedule-calendar__header">
    <div>
      <h5 class="mb-0">
        <fa-icon [icon]="faCalendarDays" class="me-2"></fa-icon>
        Schedule Calendar
      </h5>
    </div>

    <div class="schedule-calendar__controls">
      <button type="button" class="btn btn-outline-primary btn-sm" (click)="previousPeriod()">
        <fa-icon [icon]="faChevronLeft"></fa-icon>
      </button>

      <button type="button" class="btn btn-outline-primary btn-sm" (click)="today()">
        Today
      </button>

      <button type="button" class="btn btn-outline-primary btn-sm" (click)="nextPeriod()">
        <fa-icon [icon]="faChevronRight"></fa-icon>
      </button>
    </div>
  </div>

  <div class="card-body">
    <div class="row text-center mb-3">
      <div class="col-md-4 mt-2">
        <div *ngIf="view === CalendarView.Month" class="d-flex align-items-center justify-content-center gap-2">
          <select class="form-select schedule-calendar-select" style="width: auto; display: inline-block;" (change)="onMonthChange(+$any($event.target).value)">
            <option *ngFor="let month of months" [value]="month.value" [selected]="month.value === currentMonth">
              {{ month.label }}
            </option>
          </select>

          <select class="form-select schedule-calendar-select" style="width: auto; display: inline-block;" (change)="onYearChange(+$any($event.target).value)">
            <option *ngFor="let year of years" [value]="year" [selected]="year === currentYear">
              {{ year }}
            </option>
          </select>
        </div>

      </div>

      <div class="col-md-4">
        <h3>
          {{ viewDate | calendarDate:(view + 'ViewTitle'):'en' }}
        </h3>
      </div>

      <div class="col-md-4">
        <div class="btn-group">
          <button type="button" class="btn btn-primary" [class.active]="view === CalendarView.Month"
            (click)="setView(CalendarView.Month)">
            Month
          </button>

          <button type="button" class="btn btn-primary" [class.active]="view === CalendarView.Week"
            (click)="setView(CalendarView.Week)">
            Week
          </button>

          <button type="button" class="btn btn-primary" [class.active]="view === CalendarView.Day"
            (click)="setView(CalendarView.Day)">
            Day
          </button>
        </div>
      </div>
    </div>

    <div [ngSwitch]="view">
      <mwl-calendar-month-view
        *ngSwitchCase="CalendarView.Month"
        [viewDate]="viewDate"
        [events]="events"
        [activeDayIsOpen]="activeDayIsOpen"
        [refresh]="refresh"
        [cellTemplate]="CUSTOM_CELL_TEMPLATE"
        [openDayEventsTemplate]="CUSTOM_OPEN_DAY_TEMPLATE"
      ></mwl-calendar-month-view>

      <mwl-calendar-week-view
        *ngSwitchCase="CalendarView.Week"
        [viewDate]="viewDate"
        [events]="events"
        [refresh]="refresh"
        [eventTemplate]="CUSTOM_WEEK_TEMPLATE"
      ></mwl-calendar-week-view>

      <mwl-calendar-day-view
        *ngSwitchCase="CalendarView.Day"
        [viewDate]="viewDate"
        [events]="events"
        [refresh]="refresh"
        [eventTemplate]="CUSTOM_DAY_TEMPLATE"
      ></mwl-calendar-day-view>
    </div>
  </div>
</div>

<!-- MONTH CELL TEMPLATE -->
<ng-template #CUSTOM_CELL_TEMPLATE let-day="day" let-locale="locale">
  <div class="cal-cell-top schedule-cal-cell-top">
    <span *ngIf="day.badgeTotal > 0" class="cal-day-badge">
      {{ day.badgeTotal }}
    </span>

    <span class="cal-day-number">
      {{ day.date | calendarDate:'monthViewDayNumber':locale }}
    </span>
  </div>

  <div class="schedule-month-events">
    <div class="schedule-month-event-row" *ngFor="let event of day.events"
      [ngStyle]="setEventBgColor(event.meta.scheduleItem)"
      (click)="$event.stopPropagation(); openDetails(event.meta.scheduleItem)" [ngbPopover]="eventInformationPopover"
      [popoverContext]="{ scheduleItem: event.meta.scheduleItem }" triggers="mouseenter:mouseleave" container="body"
      placement="top">
      <small class="schedule-month-event-title">
        {{ event.meta.scheduleItem.clientName }} {{ event.meta.scheduleItem.projectName }} -
        {{ event.meta.scheduleItem.itemCategory }}
      </small>
    </div>
  </div>
</ng-template>

<!-- OPEN DAY TEMPLATE -->
<ng-template #CUSTOM_OPEN_DAY_TEMPLATE let-isOpen="isOpen" let-events="events" let-date="date">
  <div *ngIf="isOpen" class="schedule-open-day p-2">
    <h5 class="mb-2">
      {{ date | calendarDate:'monthViewDayNumber':'en' }}
    </h5>

    <div *ngFor="let event of events" class="schedule-open-day-row" [ngStyle]="setEventBgColor(event.meta.scheduleItem)"
      (click)="openDetails(event.meta.scheduleItem)">
      <strong>
        {{ event.meta.scheduleItem.clientName }} {{ event.meta.scheduleItem.projectName }} -
        {{ event.meta.scheduleItem.itemCategory }}
      </strong>

      <small class="ms-2">
        {{ formatDateTime(event.meta.scheduleItem.scheduledFor) }}
      </small>
    </div>
  </div>
</ng-template>

<!-- WEEK TEMPLATE -->
<ng-template #CUSTOM_WEEK_TEMPLATE let-weekEvent="weekEvent">
  <div class="schedule-week-event" [ngStyle]="setEventBgColor(weekEvent.event.meta.scheduleItem)"
    (click)="openDetails(weekEvent.event.meta.scheduleItem)" [ngbPopover]="eventInformationPopover"
    [popoverContext]="{ scheduleItem: weekEvent.event.meta.scheduleItem }" triggers="mouseenter:mouseleave"
    container="body" placement="top">
    <small class="schedule-week-event-title">
      {{ event.meta.scheduleItem.clientName }} {{ event.meta.scheduleItem.projectName }} -
        {{ event.meta.scheduleItem.itemCategory }}
    </small>
  </div>
</ng-template>

<!-- DAY TEMPLATE -->
<ng-template #CUSTOM_DAY_TEMPLATE let-weekEvent="weekEvent">
  <div class="schedule-week-event" [ngStyle]="setEventBgColor(weekEvent.event.meta.scheduleItem)"
    (click)="openDetails(weekEvent.event.meta.scheduleItem)" [ngbPopover]="eventInformationPopover"
    [popoverContext]="{ scheduleItem: weekEvent.event.meta.scheduleItem }" triggers="mouseenter:mouseleave"
    container="body" placement="top">
    <small class="schedule-week-event-title">
      {{ event.meta.scheduleItem.clientName }} {{ event.meta.scheduleItem.projectName }} -
      {{ event.meta.scheduleItem.itemCategory }}
    </small>
  </div>
</ng-template>

<!-- POPOVER -->
<ng-template #eventInformationPopover let-scheduleItem="scheduleItem">
  <div class="schedule-event-popover">
    <strong>{{ event.meta.scheduleItem.clientName }} {{ scheduleItem.projectName }}</strong>

    <p class="mb-0">
      {{ scheduleItem.itemCategory }}
    </p>

    <p class="mb-0">
      {{ scheduleItem.status }}
    </p>

    <p class="mb-0">
      {{ formatDateTime(scheduleItem.scheduledFor) }}
    </p>

    <p class="mb-0 text-muted">
      {{ scheduleItem.source }}
    </p>
  </div>
</ng-template>